export default __webpack_public_path__ + "static/block1-0ca9b74a7e2e96d5eee2bbf598e7a9ee.png";